<div mat-dialog-title class="ds">
  <span>{{ appStrings.leads_mergeLeadWithAccount }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="content ds">
  <div class="dialog-body">
    @if (loading) {
      <div class="modal-loading-overlay">
        <p>{{ appStrings.pleaseWait }}</p>
        <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
      </div>
    }

    <!-- Lead Name -->
    <div class="info-row">
      <typography id="lead-name-label" class="label" variant="mat-caption-1" weight="regular">
        {{ appStrings.leads_mergeLeadName }}
      </typography>
      <typography id="lead-name" class="details" variant="mat-body-1" weight="medium">
        {{ record.name1 }}
      </typography>
    </div>

    <ds-divider></ds-divider>

    <!-- Account Name typeahead -->
    <div class="account-search-container">
      <ds-autocomplete id="merge-account-search" class="fill-width no-subscript"
        [label]="appStrings.leads_mergeAccountSearch"
        label_orientation="vertical-label"
        [options]="accountOptions"
        [control]="form.controls.account"
        fullFilter="true"
        drop_icon="search">
      </ds-autocomplete>
    </div>

    <!-- Selected Account Details -->
    @if (selectedAccount) {
      <div class="account-details">
        <div class="detail-row">
          <div class="detail-column">
            <typography id="bp-number-label" class="label" variant="mat-caption-1" weight="regular">
              {{ appStrings.label_bpNumber }}
            </typography>
            <typography id="bp-number" class="details" variant="mat-body-1" weight="medium">
              {{ selectedAccount.bpNumber }}
            </typography>
          </div>
          <div class="detail-column">
            <typography id="account-name-label" class="label" variant="mat-caption-1" weight="regular">
              {{ appStrings.leads_mergeAccountName }}
            </typography>
            <typography id="account-name" class="details" variant="mat-body-1" weight="medium">
              {{ selectedAccount.name }}
            </typography>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-column full-width">
            <typography id="account-address-label" class="label" variant="mat-caption-1" weight="regular">
              {{ appStrings.leads_mergeAccountAddress }}
            </typography>
            <typography id="account-address" class="details" variant="mat-body-1" weight="medium">
              {{ selectedAccount.displayAddress }}
            </typography>
          </div>
        </div>
      </div>
    }

    <!-- Cannot be undone banner -->
    <ds-alert alert_type="info" [alert_message]="appStrings.leads_mergeCannotBeUndone"></ds-alert>

    <!-- UK/DE Price Matrix warning + acknowledgment -->
    @if (isEuropeanLocale && selectedAccount) {
      <div class="ds alert info">
        <div class="alert-message">
          <span class="alert-title"
            [innerHTML]="appStrings.leads_mergePriceMatrixWarning
              .replaceAll('{0}', record.name1)
              .replaceAll('{1}', selectedAccount.name)">
          </span>
        </div>
      </div>
      <ds-checkbox id="merge-acknowledge" class="acknowledge-checkbox"
        [label]="appStrings.leads_mergeAcknowledge"
        [control]="form.controls.acknowledge">
      </ds-checkbox>
    }

  </div>
</div>

<div mat-dialog-actions align="end" class="ds dialog-actions">
  <div class="dialog-btn-wrapper">
    <ds-button id="merge-cancel-button" variant="label-only" size="medium"
      type="tertiary" (onClick)="close()"
      [label]="appStrings.button_cancel">
    </ds-button>
    <ds-button id="merge-confirm-button" variant="label-only" size="medium"
      type="primary" (onClick)="merge()"
      [label]="appStrings.leads_mergeButton"
      [isDisabled]="!canMerge">
    </ds-button>
  </div>
</div>

<ds-dialog
  id="mergeConfirmDialog"
  [title]="appStrings.leads_mergeConfirmTitle"
  [description]="confirmDialogContent"
  [actionButtons]="confirmDialogButtons"
  [open]="confirmDialogOpen$">
</ds-dialog>
